import { Suspense } from 'react';
import { IUIUrval, RutinUrvalType } from '../../../../Types/UrvalTypes';
import UrvalDialog from '../UrvalDialog/UrvalDialog';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import InfoText from '../../../InfoText/InfoText';
import { RutinUrvalListQueryVariables } from '../SavedUrval/Queries/RutinUrvalListQuery/_QueryTypes/RutinUrvalListQuery';
import KodbehorighetInfo from '../../../KodbehorighetInfo/KodbehorighetInfo';

interface IProps {
  urval: IUIUrval | null;
  setUrval: (newUrval: IUIUrval) => void;
  collectionName: string;
  rutinUrvalList?: RutinUrvalType[] | null;
  rutinUrvalVariables?: RutinUrvalListQueryVariables;
  routineID?: number;
  groupID?: string;
  codeSystemID?: string;
  usageCode?: string;
  onClose: () => void;
  open: boolean;
  kodbehorigheturval: IUIUrval;
  kodplanUrval: boolean;
  placeHolder?: string | undefined;
  disableVirtualTreeSelect?: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  kodbehorighetContainer: {
    display: 'flex',
    alignItems: 'center',
  },
});

/**
 * En dialog för att visa det kompletta användarurvalet. Urval kan sparas, öppnas  och redigeras här.
 */
export const AdvancedUrvalDialog: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const {
    urval,
    setUrval,
    collectionName,
    rutinUrvalList,
    rutinUrvalVariables,
    routineID,
    codeSystemID,
    open,
    onClose,
    kodbehorigheturval,
    classes,
    kodplanUrval,
    placeHolder,
  } = props;

  const { savedUrvalProps } = kodbehorigheturval;
  const kodbehorigheturvalNamn =
    savedUrvalProps != null ? savedUrvalProps.namn : 'Okänt namn';

  return (
    <>
      <Suspense fallback={null}>
        <UrvalDialog
          kodplanUrval={kodplanUrval}
          setUrval={setUrval}
          collectionName={collectionName}
          rutinUrvalList={rutinUrvalList}
          rutinUrvalVariables={rutinUrvalVariables}
          routineID={routineID}
          codeSystemID={codeSystemID}
          urval={urval}
          open={open}
          onClose={onClose}
          onCommit={onClose}
          openFieldPickerWithAllExpandableOpen={true}
          fieldSortMode="CustomSortOrder"
          placeHolder={placeHolder}
          disableVirtualTreeSelect={props.disableVirtualTreeSelect}
          kodbehorighet={
            <div className={classes.kodbehorighetContainer}>
              <InfoText
                text={`Kodbehörighet: ${kodbehorigheturvalNamn}`}
                tooltipText="Visa urval för kodbehörigheten"
                dialogTitle={`Urval för ${kodbehorigheturvalNamn}`}
                textColor="inherit"
                buttonColor="inherit"
                buttonMargin="none"
                buttonPadding="normal"
                buttonNoBottomMargin={false}
                buttonNoTopMargin={false}
              >
                <KodbehorighetInfo kodbehorigheturval={[kodbehorigheturval]} />
              </InfoText>
            </div>
          }
          hideUrvalHitIndicator
        />
      </Suspense>
    </>
  );
};

export default withStyles(AdvancedUrvalDialog, styles);
